'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00249 from "./presto.-Two-Factor-Auth-View$$anon$9.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dSeed$002dToken$0024 from "./presto.-Two-Factor-Auth-View$-Seed-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Tables$$anon$8() {
  this.bJw = null;
  this.bJo = null;
  this.bJp = false;
  this.bJx = null;
  this.bJy = false;
  this.bJB = null;
  this.bJu = null;
  this.bJv = false;
  this.bJq = null;
  this.bJr = false;
  this.bJs = null;
  this.bJt = false;
  this.bJz = false;
  this.bJA = false;
  this.bJw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bJB = "SeedToken";
}
export { $c_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $c_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
$p = $c_Lpresto_TwoFactorAuthView$Tables$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Tables$$anon$8;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Tables$$anon$8() {
}
export { $h_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $h_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
$h_Lpresto_TwoFactorAuthView$Tables$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bJw;
});
$p.M = (function() {
  if ((!this.bJp)) {
    this.bJo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bJp = true;
  }
  return this.bJo;
});
$p.O = (function() {
  if ((!this.bJy)) {
    this.bJx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bJy = true;
  }
  return this.bJx;
});
$p.E = (function() {
  return this.bJB;
});
$p.t = (function() {
  if ((!this.bJv)) {
    this.bJu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bJv = true;
  }
  return this.bJu;
});
$p.N = (function() {
  if ((!this.bJr)) {
    this.bJq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bJr = true;
  }
  return this.bJq;
});
$p.Q = (function() {
  if ((!this.bJt)) {
    this.bJs = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00249.$c_Lpresto_TwoFactorAuthView$$anon$9();
    this.bJt = true;
  }
  return this.bJs;
});
$p.v = (function() {
  if ((!this.bJA)) {
    this.bJz = false;
    this.bJA = true;
  }
  return this.bJz;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee86) => ((p) => \u03b4scrutinee86.cFD(p)))($j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dSeed$002dToken$0024.$m_Lpresto_TwoFactorAuthView$SeedToken$())));
});
var $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Tables$$anon$8, "presto.TwoFactorAuthView$Tables$$anon$8", ({
  Uf: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Tables$$anon$8.js.map
